/**
 * Stash for the admin's own tokens while impersonating another user.
 * Presence of the stash IS the "currently impersonating" signal; the 401
 * handler restores it when the 15-minute impersonation token dies.
 */

const STASH_KEY = 'nord-living-impersonation-stash';

export interface ImpersonationStash {
  accessToken: string;
  refreshToken: string;
  tokenExpiry: string;
  targetEmail: string;
}

export function saveImpersonationStash(stash: ImpersonationStash): void {
  localStorage.setItem(STASH_KEY, JSON.stringify(stash));
}

export function readImpersonationStash(): ImpersonationStash | null {
  const raw = localStorage.getItem(STASH_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as ImpersonationStash;
    return parsed.accessToken ? parsed : null;
  } catch {
    return null;
  }
}

export function clearImpersonationStash(): void {
  localStorage.removeItem(STASH_KEY);
}
